import { QueryClient } from '@tanstack/react-query';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';
import type { paths } from '../types/ff.v1'; // generated by openapi-typescript
import { CLIENT_CHANNEL, CLIENT_CHANNEL_HEADER } from './api-client';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

// Use relative URLs so the same bundle works in every environment:
//   • Production / fraudfront.local: nginx reverse-proxies /api/* to the backend
//   • Dev: serve the app through a host (fraudfront.local or similar) that
//     proxies /api/* to localhost:8080, or run a Next dev rewrite.
// A hardcoded http://localhost:8080 baseUrl trips Chrome's mixed-content block
// when the page is loaded over HTTPS.
const fetchClient = createFetchClient<paths>({
  // Declared as a client-level default header so openapi-fetch merges it into
  // the request alongside its auto `Content-Type: application/json` rather than
  // replacing the built Request's headers (which would drop Content-Type and
  // get JSON POSTs rejected with 415). The custom `fetch` only adds credentials.
  headers: { [CLIENT_CHANNEL_HEADER]: CLIENT_CHANNEL },
  fetch: (input: RequestInfo, init?: RequestInit) =>
    fetch(input, { ...init, credentials: 'include' })
});
export const fraudFrontQueryClient = createClient(fetchClient);
